import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { H1, Logo, Text } from 'components';
import { theme, toRem } from 'design';

export const AccountSetupContent = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(theme.space.xl)};
  justify-items: center;
  width: 100%;
  max-width: ${toRem(620)};
  height: auto;
  padding: ${toRem(theme.space.xl)};
  text-align: center;

  > form,
  > img {
    width: 100%;
  }

  > img {
    max-width: ${toRem(300)};
  }

  @media (min-width: ${theme.breakpoint.med}px) {
    grid-gap: ${toRem(theme.space['3xl'])};
    padding: ${toRem(theme.space['3xl'])};

    > form,
    > img {
      max-width: ${toRem(350)};
    }
  }

  @media (min-width: ${theme.breakpoint.xlarge}px) {
    max-width: ${toRem(768)};
  }
`;

const AccountSetupHeaderLayout = styled.header`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: auto;
  text-align: center;
`;

const HeaderTitle = styled(H1)`
  margin-bottom: 0;

  @media (min-width: ${theme.breakpoint.med}px) {
    margin-top: ${toRem(theme.space.xl)};
  }
`;

const HeaderMessage = styled(Text).attrs({
  size: 'default',
})`
  margin-top: ${toRem(theme.space.md)};
`;

interface IAccountSetupHeaderProps {
  title?: string;
  message?: string | ReactNode;
  logoVisible?: boolean;
  className?: string;
}

export const AccountSetupHeader: React.FC<IAccountSetupHeaderProps> = ({ logoVisible = false, title, message, className, ...rest }) => (
  <AccountSetupHeaderLayout className={className} {...rest}>
    {logoVisible && <Logo />}
    <HeaderTitle data-cy="title">{title}</HeaderTitle>
    {message && <HeaderMessage data-cy="subtitle">{message}</HeaderMessage>}
  </AccountSetupHeaderLayout>
);

export const AccountSetupFooter = styled.footer`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(theme.space.xl)};
  justify-items: center;
  width: 100%;
  height: auto;
  padding: ${toRem(theme.space['3xl'])} 0 0;
  border-top: ${toRem(1)} solid ${theme.color.neutral[200]};

  > * {
    width: fit-content;
  }
`;

export const AccountSetupNotificationsLayout = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(theme.space.xl)};
  width: 100%;
`;
